interface LandingCTAProps {
  onCreateLink: () => void;
}

export function LandingCTA({ onCreateLink }: LandingCTAProps) {
  // The gap below the card is CTA bottom-padding + the footer's own margin-top, which makes it
  // larger than the top. Pad the top to match that combined lower gap so the card sits with
  // equal breathing room above and below.
  return (
    <section id="start" style={{ padding: "96px 0 clamp(20px, 3vw, 40px)" }}>
      <div className="lp-container">
        <div
          data-reveal
          style={{
            position: "relative",
            overflow: "hidden",
            background: "var(--lp-plum-900)",
            color: "var(--lp-cream)",
            borderRadius: "var(--lp-radius-lg)",
            padding: "clamp(32px, 4vw, 56px)",
            textAlign: "center",
          }}
        >
          {/* Ambient drifting glow — matches the Intelligence section's living gradient. */}
          <div
            className="lp-anim-drift"
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: "-40% -20% auto auto",
              width: "70%",
              height: "180%",
              background: "radial-gradient(closest-side, rgba(184,166,221,.28), transparent 70%)",
              pointerEvents: "none",
            }}
          />
          <div style={{ position: "relative", zIndex: 1 }}>
            <span style={{ fontFamily: "var(--lp-mono)", fontSize: 11, letterSpacing: ".16em", textTransform: "uppercase", color: "rgba(255,253,250,.5)" }}>
              Get started
            </span>
            <h2
              className="lp-h1"
              style={{ margin: "14px 0 0", color: "var(--lp-cream)", fontSize: "clamp(30px, 4.2vw, 52px)" }}
            >
              Your booking link, <em style={{ color: "var(--lp-lavender)" }}>in minutes.</em>
            </h2>
            <p style={{ fontSize: 17, color: "rgba(255,253,250,.72)", margin: "20px auto 0", maxWidth: "40ch" }}>
              Free for solo hosts. No credit card. Cancel any time.
            </p>
            <button
              type="button"
              className="lp-btn lp-btn-lg"
              onClick={onCreateLink}
              style={{
                marginTop: 28,
                background: "var(--lp-cream)",
                color: "var(--lp-plum-900)",
                boxShadow: "var(--lp-shadow-lift)",
              }}
            >
              Create your BunnyCal
              <span style={{ fontSize: 18, lineHeight: 0 }}>→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
